import { Button, Flex, Text } from '@actovos-consulting-group/ui-core';
import React, { createElement } from 'react';
import { useToggle } from 'react-use';
import LoginForm from './login-form';
import RegisterForm from './register-form';

const Register = ({ onClick, onSuccess }) => (
  <>
    <LoginForm onSuccess={onSuccess} />
    <Flex alignItems="center" justifyContent="center" mt={20}>
      <Flex alignItems="center">
        <Text mr={20}>Need an account?</Text>
        <Button onClick={onClick}>Register</Button>
      </Flex>
    </Flex>
  </>
);

const Login = ({ onClick, onSuccess }) => (
  <>
    <RegisterForm onSuccess={onSuccess} />
    <Flex alignItems="center" justifyContent="center" mt={20}>
      <Flex alignItems="center">
        <Text mr={20}>Already have an account?</Text>
        <Button onClick={onClick}>Login</Button>
      </Flex>
    </Flex>
  </>
);

const LoginRegister = ({ onSuccess }) => {
  const [showLogin, toggle] = useToggle(true);
  return createElement(showLogin ? Login : Register, {
    onSuccess,
    onClick: () => {
      toggle();
    },
  });
};

export default LoginRegister;
